/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_StepsInputs */

const en_recipe_steps = /** @type {(inputs: Recipe_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steps`)
};

const de_recipe_steps = /** @type {(inputs: Recipe_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zubereitung`)
};

/**
* | output |
* | --- |
* | "Steps" |
*
* @param {Recipe_StepsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_steps = /** @type {((inputs?: Recipe_StepsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_StepsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_steps(inputs)
	return en_recipe_steps(inputs)
});